export const landingPath = (preferences) => {
  if (preferences?.landing !== "calendar") return "/dashboard";
  const view = ["day", "week", "month"].includes(preferences?.landing_view)
    ? preferences.landing_view
    : "week";
  return `/calendar?view=${view}`;
};
